import { z } from "zod"

export const SOURCES = [`PVWatts`, `ReadingEntry`, `SolarPvModel`] as const

export const Sources = {
  PVWatts: `PVWatts`,
  ReadingEntry: `ReadingEntry`,
  SolarPvModel: `SolarPvModel`,
} as const

export const sourceSchema = z.object({
  sourceId: z.enum(SOURCES),
  sourceVersion: z.string().nullable(),
  type: z.string(),
  name: z.string().optional(),
})

export type Source = z.infer<typeof sourceSchema>
